/** Hindi: rate estimates, what they rest on, suggestions, market answers, and the note on far-off offers. */
export const estimate = {
    "estimate.range_job": "{city} में {trade}{scope}: आम तौर पर पूरे काम का {low}–{high}।",
    "estimate.range_month": "{city} में {trade}{scope}: आम तौर पर महीने का {low}–{high}।",
    "estimate.range_visit": "{city} में {trade}{scope}: आम तौर पर एक बार का {low}–{high}।",
    "estimate.range_day": "{city} में {trade}{scope}: आम तौर पर एक दिन का {low}–{high}।",
    "estimate.range_hour": "{city} में {trade}{scope}: आम तौर पर एक घंटे का {low}–{high}।",
    "estimate.range_sqft": "{city} में {trade}{scope}: आम तौर पर पेंट होने वाले एक वर्ग फ़ुट का {low}–{high}।",
    "estimate.scope": " ({scope})",
    "estimate.rooms.bhk1": "1 बीएचके",
    "estimate.rooms.bhk2": "2 बीएचके",
    "estimate.rooms.bhk3": "3 बीएचके",
    "estimate.rooms.bhk4_plus": "4 बीएचके या ज़्यादा",
    "estimate.labour.yes": "सिर्फ़ मज़दूरी",
    "estimate.labour.no": "पेंट के साथ",
    "estimate.frequency.daily": "रोज़",
    "estimate.frequency.alternate_days": "एक दिन छोड़कर",
    "estimate.frequency.weekly": "हफ़्ते में एक बार",
    "estimate.people.1_2": "1–2 लोग",
    "estimate.people.3_4": "3–4 लोग",
    "estimate.people.5_plus": "5 या ज़्यादा लोग",
    "estimate.meals.1": "दिन में 1 बार खाना",
    "estimate.meals.2": "दिन में 2 बार खाना",
    "estimate.meals.3": "दिन में 3 बार खाना",
    "estimate.hours.up_to_6": "दिन में 6 घंटे तक",
    "estimate.hours.7_to_9": "दिन में 7–9 घंटे",
    "estimate.hours.10_plus": "दिन में 10 या ज़्यादा घंटे",
    "estimate.problem.fan": "पंखा",
    "estimate.problem.switch": "स्विच",
    "estimate.problem.light": "बत्ती",
    "estimate.problem.wiring": "वायरिंग",
    "estimate.problem.leak": "रिसाव",
    "estimate.problem.tap": "नल",
    "estimate.problem.blockage": "रुकावट",
    "estimate.problem.toilet": "टॉयलेट",
    "estimate.problem.door": "दरवाज़ा",
    "estimate.problem.repair": "मरम्मत",
    "estimate.problem.assembly": "फ़र्नीचर जोड़ना",
    "estimate.problem.service": "सर्विस",
    "estimate.problem.gas_refill": "गैस भरना",
    "estimate.problem.install": "लगाना",
    "estimate.jobs.one": "{place} में GigSync के {count} काम से।",
    "estimate.jobs.other": "{place} में GigSync के {count} कामों से।",
    "estimate.reason_jobs.one": "इस काम का आम रेट {low}–{high} है, GigSync के {count} काम से।",
    "estimate.reason_jobs.other": "इस काम का आम रेट {low}–{high} है, GigSync के {count} कामों से।",
    "estimate.market_none": "{place} में {trade} का आम रेट अभी नहीं बता सकता: GigSync पर काम और वेब पर दाम अभी बहुत कम हैं।",
    "estimate.amount_below": "{amount} इस दायरे से कम है।",
    "estimate.amount_within": "{amount} इसी दायरे में है।",
    "estimate.amount_above": "{amount} इस दायरे से ज़्यादा है।",
    "estimate.answer": "{text}",
    "estimate.legal_min": "इसमें कुछ भी क़ानूनी न्यूनतम {min} से कम नहीं है।",
    "estimate.suggest_rate": "मेरा सुझाव है {price} से शुरू करें। इसे चुनें, या अपना दाम बताएँ।",
    "estimate.suggest_min": "मेरा सुझाव है कम से कम {price} लें। इसे चुनें, या अपना दाम बताएँ।",
    "estimate.suggest_budget": "मेरा सुझाव है {price} का बजट। इसे चुनें, या अपना बताएँ।",
    "estimate.use": "{price} रखें",
    "estimate.below": "इस काम के आम रेट ({low}–{high}) से काफ़ी कम।",
    "estimate.above": "इस काम के आम रेट ({low}–{high}) से काफ़ी ज़्यादा।",
};
//# sourceMappingURL=estimate.js.map